import React from 'react';
import PropTypes from 'prop-types';

import './loadingModal.scss';

const ModalLoading = ({ show, progress, text }) => {
  if (!show) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="progress-bar-background">
          <div
            className="progress-bar-fill"
            style={{ width: `${(progress.current / progress.total) * 100}%` }}
          />
          <span className="progress-text">
            {progress.current}
            {' '}
            of
            {' '}
            {progress.total}
          </span>
        </div>
        <p className="progress-description">
          {text}
        </p>
      </div>
    </div>
  );
};

ModalLoading.propTypes = {
  show: PropTypes.bool.isRequired,
  progress: PropTypes.shape({
    current: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
  }).isRequired,
  text: PropTypes.string.isRequired,
};

export default ModalLoading;
